













import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';
import ContractItem from '@/domain/contract/entity/contract-item.entity';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';

@Component({
  components: {
    VbTooltipSlot,
  },
})
export default class ManageCalculationButton extends Vue {
  @Prop() contractItem!: ContractItem;

  @Prop() disable!: boolean;

  get hasCalculation() {
    return this.contractItem.hasCalculationRules;
  }

  get iconColor() {
    return this.hasCalculation ? 'blue' : 'red';
  }

  get tooltipText() {
    return this.hasCalculation ? 'Gerenciar Cálculo' : 'Cálculo Inconsistente';
  }

  goToManageCalculation() {
    this.$router.push({
      name: 'GestaoContrato',
      params: {
        id: this.contractItem.id,
        reviewed: this.contractItem.reviewed ? 'S' : 'N',
      },
    })
  }
}
